

























import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
@Component({
    name: 'MessageDetails',
    mixins: [MapResolver],
})
export default class MessageDetails extends Vue {
    @Injectable() public container!: Container;

    @Prop() public messageDetailData: any;

    public onekeysearchtodetail = {
        name: '',
    };
    private returnBackName: any = '';


    public async backDataPanelFn() {
        // 关闭messageDetails的组件面板
        this.$store.dispatch('searchStore/isShowMessageDetailEmit', false);
        // 打开结果组件面板
        this.$store.dispatch('searchStore/isShowSearchResultEmit', true);
        // 去掉高亮
        const component: any = await  this.getComponent();
        component.removehighlight();
        component.closePopup();

    }

    // 详细信息已经传递过来
    @Watch('messageDetailData', {deep: true})
    private show(val: any) {
            this.onekeysearchtodetail = val.data;
            this.returnBackName =  this.$store.state.searchStore.commonKeyword;

    }

    private async aroundSearch() {
        this.$store.dispatch('searchStore/aroundNameEmit', this.onekeysearchtodetail.name);
        this.$store.dispatch('searchStore/isShowRoundFlagEmit', true);

        // 关闭messageDetails的组件面板
        this.$store.dispatch('searchStore/isShowMessageDetailEmit', false);

        const component: any = await  this.getComponent();
       // component.unload();
        component.removeBuffer();
        // component.closePopup();
    }

    private getComponent(moduleName: string = 'Search', componentName: string = 'POISearch') {
        const p = new Promise((resolve, reject) => {
            (this as any).resolveMap('map').then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName, componentName);
                resolve(component);
            }).catch(() => { reject('获取地图组件失败'); });
        });
        return p;
    }
}
